import _classCallCheck from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import Shareable from '@shared/models/shareable';
import Person from '@shared/models/person';
import TimeSpan, { NullTimeSpan } from '@shared/models/time_span';

var BusySpan = /*#__PURE__*/function (_Shareable) {
  _inherits(BusySpan, _Shareable);

  var _super = _createSuper(BusySpan);

  function BusySpan() {
    _classCallCheck(this, BusySpan);

    return _super.apply(this, arguments);
  }

  _createClass(BusySpan, [{
    key: "getStart",
    value: function getStart() {
      return this.time.start;
    }
  }, {
    key: "getEnd",
    value: function getEnd() {
      return this.time.end;
    }
  }, {
    key: "equals",
    value: function equals(other) {
      return this.id === other.id;
    }
  }], [{
    key: "fromPlainObject",
    value: function fromPlainObject(_ref) {
      var id = _ref.id,
          time = _ref.time,
          person = _ref.person,
          name = _ref.name;
      var busySpan = new this();
      busySpan.id = id || null;
      busySpan.time = TimeSpan.fromPlainObject(time);
      busySpan.person = Person.fromPlainObject(person);
      busySpan.name = name || null;
      return busySpan;
    }
  }, {
    key: "fromTimeSpan",
    value: function fromTimeSpan(timeSpan) {
      return this.fromPlainObject({
        time: timeSpan.toPlainObject()
      });
    }
  }, {
    key: "shareableFields",
    value: function shareableFields() {
      return ['id', 'time', 'person', 'name'];
    }
  }]);

  return BusySpan;
}(Shareable);

export { BusySpan as default };
export var NullBusySpan = /*#__PURE__*/function (_BusySpan) {
  _inherits(NullBusySpan, _BusySpan);

  var _super2 = _createSuper(NullBusySpan);

  function NullBusySpan() {
    var _this;

    _classCallCheck(this, NullBusySpan);

    _this = _super2.call(this);
    _this.time = new NullTimeSpan();
    return _this;
  }

  _createClass(NullBusySpan, [{
    key: "isNull",
    value: function isNull() {
      return true;
    }
  }]);

  return NullBusySpan;
}(BusySpan);